export const THANK_YOU_PNG = require(`./assets/png/Thankyou-career.png`);
export const EMAIL_SEND_PNG = require(`./assets/png/emailSend.png`);
export const FIRST_TIME_CHECKER_PNG = require('./assets/png/FirstTimeChecker.png');
